import React from 'react';
import { Link } from 'react-router-dom';

import {
  Container,
  Content,
  LearnMore,
  AboutImageContainer,
  AboutImageContent,
  BlueBackground,
} from './styles';
import AboutImage from '../../../../assets/01-image.png';

const AboutUs: React.FC = () => {
  return (
    <Container id="about-us">
      <Content>
        <h1>
          PEQUENOS MOMENTOS
          <br />
          GERAM
          <span> GRANDES IDEIAS</span>
        </h1>

        <p>
          Somos um pequeno time composto por designers, desenvolvedores e
          animadores , e apesar de pequenos, trabalhamos para entregar jogos com
          altíssima qualidade e criativade ao mercado.
        </p>

        <LearnMore>
          <Link to="/sobre">SAIBA MAIS</Link>
        </LearnMore>
      </Content>
      <AboutImageContainer>
        <AboutImageContent>
          <img src={AboutImage} alt="Computador" />
        </AboutImageContent>

        <BlueBackground>
          <div>
            <h1>.01</h1>
          </div>
        </BlueBackground>
      </AboutImageContainer>
    </Container>
  );
};

export default AboutUs;
